import axiosClient from './axiosClient';

const ordersApi = {
  // Checkout (cliente autenticado)
  createOrder: (data) => axiosClient.post('/orders', data),

  // Administracion de pedidos (solo administrador)
  getOrders: (params) => axiosClient.get('/orders', { params }),
  // Pedidos del propio cliente autenticado (panel del cliente / "Mis pedidos").
  getMyOrders: (params) => axiosClient.get('/orders/mine', { params }),
  // Venta express: pedido que el propio administrador registra desde el panel (ver
  // ExpressSalePage), sin pasar por el checkout de la tienda.
  createExpressOrder: (data) => axiosClient.post('/orders/express', data),
  // Pedido con su detalle completo, por ejemplo al reabrirlo desde el historial de
  // boletas y facturas (ver InvoicesListPage) en vez de desde la lista de pedidos.
  getOrder: (id) => axiosClient.get(`/orders/${id}`),
  getSalesStats: (granularity) => axiosClient.get('/orders/stats', { params: { granularity } }),
  updateOrderStatus: (id, status) => axiosClient.put(`/orders/${id}`, { status }),
  // Datos editables del pedido desde el panel (ej. el nombre de la nota de venta: customer_name).
  updateOrder: (id, data) => axiosClient.put(`/orders/${id}`, data),
  deleteOrder: (id) => axiosClient.delete(`/orders/${id}`),
  getOrderStatuses: () => axiosClient.get('/order-statuses'),

  // Comprobante (boleta/factura) electronico ante SUNAT: el propio cliente o un administrador
  issueInvoice: (orderId, data) => axiosClient.post(`/orders/${orderId}/invoice`, data),
  // Reintenta el envio a SUNAT de un comprobante en estado "error" o "rechazada", sin
  // consumir un correlativo nuevo (ver OrderController::resendInvoice).
  resendInvoice: (orderId) => axiosClient.post(`/orders/${orderId}/invoice/resend`),
  // `reasonCode`: sustento del Catalogo 09 de SUNAT (ver CREDIT_NOTE_REASONS); `observation`
  // opcional. Si SUNAT ya acepto el comprobante, se le envia una nota de credito electronica con
  // ese sustento y solo se anula si SUNAT la acepta (si no, responde 422 con el motivo).
  voidInvoice: (orderId, reasonCode, observation) =>
    axiosClient.post(`/orders/${orderId}/invoice/void`, { reason_code: reasonCode, observation: observation || undefined }),
  // Completa la serie de una linea del pedido (a mano o con lectora de barras) antes de
  // poder emitir su comprobante (ver OrderDetailDialog).
  assignItemSerial: (orderId, itemId, serie) =>
    axiosClient.post(`/orders/${orderId}/items/${itemId}/serials`, { serie }),
  // `paper`: 'a4' (default) o 'ticket' (80mm, para tiketera termica ej. Fukun FK-POS80-BF).
  downloadInvoicePdf: (orderId, paper) =>
    axiosClient.get(`/orders/${orderId}/invoice/pdf`, { params: { paper }, responseType: 'blob' }),
  // Vista previa/impresion del comprobante sin emitirlo: no crea el registro ni consume
  // el correlativo (ver OrderController::previewInvoicePdf).
  previewInvoicePdf: (orderId, type, paper) =>
    axiosClient.get(`/orders/${orderId}/invoice/preview-pdf`, { params: { type, paper }, responseType: 'blob' }),
  sendInvoiceEmail: (orderId, email) =>
    axiosClient.post(`/orders/${orderId}/invoice/send-email`, email ? { email } : {}),
  // Nota de venta: documento interno sin validez tributaria (no pasa por SUNAT), disponible
  // sin importar el estado del comprobante electronico del pedido (ver OrderDetailDialog).
  downloadNotaVentaPdf: (orderId, paper) =>
    axiosClient.get(`/orders/${orderId}/nota-venta`, { params: { paper }, responseType: 'blob' }),
  // Nota de credito de un comprobante anulado (ver voidInvoice): la electronica aceptada por
  // SUNAT, o una interna si el comprobante se anulo solo en el sistema.
  downloadCreditNotePdf: (orderId, paper) =>
    axiosClient.get(`/orders/${orderId}/credit-note`, { params: { paper }, responseType: 'blob' }),

  // Mismo comprobante, pero para un pedido de invitado (sin sesion iniciada):
  // se identifica por el UUID del pedido en vez de su id secuencial.
  issueInvoiceGuest: (orderUuid, data) => axiosClient.post(`/orders/guest/${orderUuid}/invoice`, data),
  downloadInvoicePdfGuest: (orderUuid) =>
    axiosClient.get(`/orders/guest/${orderUuid}/invoice/pdf`, { responseType: 'blob' }),
  previewInvoicePdfGuest: (orderUuid, type) =>
    axiosClient.get(`/orders/guest/${orderUuid}/invoice/preview-pdf`, { params: { type }, responseType: 'blob' }),
  sendInvoiceEmailGuest: (orderUuid, email) =>
    axiosClient.post(`/orders/guest/${orderUuid}/invoice/send-email`, email ? { email } : {}),
};

export default ordersApi;
